import { observer } from "mobx-react-lite";
import { useAppContext } from "../../../shared/functions/Context";
import { useState, useEffect, FormEvent } from "react";
import React from "react";

import MODAL_NAMES from "../ModalName";
import { hideModalFromId } from "../../../shared/functions/ModalShow";
import {
  defaultTrainingRequest,
  ITrainingRequest,
} from "../../../shared/models/TrainingRequestModel";
import { defaultUser, IUser } from "../../../shared/models/User";
import "./ViewTrainingRequests.scss"; // Import the newly created SCSS file
import { dateFormat_YY_MM_DD } from "../../shared/utils/utils";

const ViewTrainingRequest = observer(() => {
  const { store, api } = useAppContext();
  const me = store.auth.me?.asJson;
  const departments = store.department.all;
  const [currentUser, setCurrentUser] = useState<IUser>({ ...defaultUser });
  const [courseRequest, setCourseRequest] = useState<ITrainingRequest>({
    ...defaultTrainingRequest,
  });
  const [loading, setLoading] = useState(false);

  const getDepartmentName = (departmentId: string) => {
    const department = departments.find(
      (dept) => dept.asJson.id === departmentId
    );
    return department ? department.asJson.name : "Unknown Department";
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (store.trainingRequest.selected) {
        await api.trainingRequest.update(courseRequest);
      } else {
        await api.trainingRequest.create(courseRequest);
      }
    } catch (error) {
      console.error("Error submitting training request:", error);
      // Handle error feedback here
    } finally {
      setLoading(false);
      onCancel();
    }
  };
  // Handle file upload changes and update the attachment array
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const uploadedFileLinks = await Promise.all(
        Array.from(files).map(async (file) => {
          // Upload file to storage and get the link
          const uploadedFileLink =
            await api.uploadManager.uploadQualificationToStorage(
              file,
              `trainingQualification/${me?.uid}`
            );
          return uploadedFileLink; // Return the uploaded file link
        })
      );

      // Add new attachments to the existing array
      setCourseRequest({
        ...courseRequest,
        attachment: [...courseRequest.attachment, ...uploadedFileLinks],
      });
    }
  };

  // Remove attachment from the array by index
  const handleRemoveAttachment = (index: number) => {
    const updatedAttachments = [...courseRequest.attachment];
    updatedAttachments.splice(index, 1); // Remove the attachment at the specified index
    setCourseRequest({
      ...courseRequest,
      attachment: updatedAttachments, // Update state with the remaining attachments
    });
  };
  const users = store.user.all.map((users) => users.asJson);
  const getName = (uid: string): string => {
    console.log("uid passed", uid);

    const currentUser = users.find((user) => user.uid === uid);
    console.log("current user", currentUser);

    return currentUser?.displayName || "Unknown Department";
  };

  useEffect(() => {
    // Load the selected personal development item into the state when the modal opens
    if (store.trainingRequest.selected) {
      setCourseRequest(store.trainingRequest.selected);
    }
  }, [store.trainingRequest.selected]);
  const onCancel = () => {
    store.personalDevelopment.clearSelected();
    hideModalFromId(
      MODAL_NAMES.EXECUTION.PERSONAL_DEVELOPMENT_VIEW_TRAINING_MODAL
    );
  };

  const purposeOptions = ["Development", "Certification", "Other"];

  return (
    <div className="view-training-modal uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      <button
        className="uk-modal-close-default"
        type="button"
        data-uk-close
      ></button>
      <div className="uk-container uk-container-large">
        <form
          onSubmit={handleSubmit}
        >
          <div className="uk-width-1-1">
          <h1 className="training-title">My Training Request</h1>
           
          </div>
          <section className="uk-section uk-section-muted custom-section">
            <div className="uk-grid uk-grid-small uk-child-width-1-2@s">
              {/* Row for Name and Email */}
              <div className="uk-margin uk-width-1-1">
              <h2 className="section-title">Employee Information</h2>
                <div className="uk-grid uk-grid-small">
                  <div className="uk-width-1-2">
                    <label className="custom-label">Name:</label>
                    <input
                      className="custom-input"
                      type="text"
                      value={getName(courseRequest.uid)}
                      onChange={(e) =>
                        setCourseRequest({
                          ...courseRequest,
                          name: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="uk-width-1-2">
                    <label className="custom-label">Email:</label>
                    <input
                      className="custom-input"
                      type="text"
                      value={courseRequest.email || currentUser?.email || ""}
                      onChange={(e) =>
                        setCourseRequest({
                          ...courseRequest,
                          email: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              {/* Other fields */}
              <div className="uk-margin">
                <label className="custom-label">Department:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={getDepartmentName(courseRequest.department)}
                  readOnly // Making it read-only if it's not editable
                />
              </div>
              <div className="uk-margin">
                <label className="custom-label">Phone Number:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.phoneNumber}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      phoneNumber: e.target.value,
                    })
                  }
                />
              </div>
              <div className="uk-margin">
                <label className="custom-label">Location:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.location}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      location: e.target.value,
                    })
                  }
                />
              </div>
              <div className="uk-margin">
                <label className="custom-label">Supervisor Name:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={getName(courseRequest.supervisor)}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      supervisor: e.target.value,
                    })
                  }
                />
              </div>

              <div className="uk-margin">
                <label className="custom-label">Supervisor Phone:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.supervisorPhone}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      supervisorPhone: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </section>

          {/* Course Information Section */}
          <section className="uk-section uk-section-muted custom-section">
            <h2 className="section-title">Course Information</h2>
            <div className="uk-grid uk-grid-small uk-child-width-1-2@m uk-grid-divider">
              {/* Course Name */}
             
              <div className="uk-margin">
              <hr/>
                <label className="custom-label">Course Name:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.courseName}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      courseName: e.target.value,
                    })
                  }
                />
              </div>

              {/* Preferred Date */}
              <div className="uk-margin">
                <label className="custom-label">Preferred Date:</label>
                <input
                  className="custom-input"
                  type="date"
                  value={dateFormat_YY_MM_DD(courseRequest.preferredDate)}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      preferredDate: e.target.valueAsNumber,
                    })
                  }
                />
              </div>

              {/* Offered By */}
              <div className="uk-margin">
                <label className="custom-label">Offered By:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.offeredBy}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      offeredBy: e.target.value,
                    })
                  }
                />
              </div>

              {/* Duration */}
              <div className="uk-margin">
                <label className="custom-label">Duration:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.duration}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      duration: e.target.value,
                    })
                  }
                />
              </div>

              {/* Location */}
              <div className="uk-margin">
                <label className="custom-label">Location:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.courseLocation}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      courseLocation: e.target.value,
                    })
                  }
                />
              </div>
              <div className="uk-margin">
                <label className="custom-label">Budget:</label>
                <input
                  className="custom-input"
                  type="number"
                  value={courseRequest.budget}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      budget: e.target.valueAsNumber,
                    })
                  }
                />
              </div>
              {/* Brief Summary */}
              <div className="uk-margin uk-width-1-1">
                <label className="custom-label">
                  Brief Summary of Course Content:
                </label>
                <textarea
                  className="uk-textarea uk-margin-small-top"
                  value={courseRequest.courseSummary}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      courseSummary: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </section>

          <section className="uk-section uk-section-muted custom-section">
            <div className="uk-width-1-2">
            <h2 className="section-title">
                Purpose of Training
              </h2>
              <div className="uk-form-controls uk-margin">
                <select
                  className="uk-select" // Added class for consistent styling
                  value={courseRequest.purpose} // Set the selected value
                  id="purpose"
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      purpose: e.target.value, // Update purpose in courseRequest
                    })
                  }
                  required // Ensure the dropdown is required
                >
                  <option value={""} disabled>
                    Select purpose...
                  </option>
                  {purposeOptions.map((purpose) => (
                    <option key={purpose} value={purpose}>
                      {purpose}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </section>

          {/* Display Uploaded Attachments */}
          <div className="uk-section uk-section-muted custom-section">
          <h2 className="section-title">Uploaded Attachments</h2>
            {courseRequest.attachment.length > 0 ? (
              <ul>
                {courseRequest.attachment.map((url, index) => (
                  <li key={index}>
                    {/* View Attachment */}
                    <button
                      type="button"
                      className="uk-section custom-section"
                      onClick={() =>
                        window.open(url, "_blank", "noopener,noreferrer")
                      }
                    >
                      View Attachment {index + 1}
                    </button>
                    {/* Remove Attachment */}
                    <button
                      type="button"
                      className="btn-remove"
                      onClick={() => handleRemoveAttachment(index)}
                    >
                      Remove
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No attachments found.</p>
            )}
          </div>

          {/* Confirmation Box */}
          <section className="uk-section uk-section-default">
            <div className="uk-margin">
              <label>
                <input
                  className="uk-checkbox uk-margin-small-right"
                  type="checkbox"
                  checked={courseRequest.confirmation}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      confirmation: e.target.checked,
                    })
                  }
                />
                I confirm that this information is true and accurate.
              </label>
            </div>
          </section>

          {/* Action Buttons */}
          <div className="uk-section uk-text-center button-container">
            <button
              type="submit"
              className="uk-section custom-section"
              style={{ marginRight: '8px' }}
              disabled={loading}
            >
              {loading ? "Updating Request..." : "Update Request"}
            </button>
            <button
              type="button"
              className="uk-section custom-section"
              style={{ backgroundColor: 'red', color: 'white', border: 'none' }}
              onClick={onCancel}
            >
              Cancel
            </button>
            {/* <button type="button" className="custom-button update-button">
            Update Information
          </button> */}
          </div>
        </form>
      </div>
    </div>
  );
});

export default ViewTrainingRequest;
